<template>
  <div>
    <div class="tw-bg-white tw-shadow tw-border-t tw-border-gray-200">
      <base-content>
        <h1 class="tw-text-2xl sm:tw-text-3xl tw-leading-tight tw-text-gray-900 tw-mb-0 tw-font-thin">Support</h1>
        <div class="tw-text-gray-600">Have a question? Send us a note and we will get back to you.</div>
      </base-content>
    </div>
    <base-content>
      <base-card>
        <ul class="tw-divide-y tw-divide-gray-200 tw-mb-0 tw-space-y-4" v-if="isLoading">
          <li v-for="i in 1" :key="i" :class="[{ 'tw-pt-4': i - 1 }, 'tw-pb-0.5']">
            <base-skeleton-loader class="tw-h-3 tw-w-36 tw-mt-1.5" />
            <div class="tw-flex tw-items-center tw-mt-3 tw-mb-4.5">
              <base-skeleton-loader class="tw-h-2 tw-w-28" />
              <base-skeleton-loader class="tw-h-2 tw-w-28 tw-ml-3" />
            </div>
          </li>
        </ul>
        <ul class="tw-divide-y tw-divide-gray-200 tw-mb-0 tw-space-y-4" v-else>
          <li v-if="isLocationFiltered === true">
            <div class="tw-text-primary tw-font-normal">{{ business.name }}</div>
            <div class="tw-flex tw-items-center tw-mt-1">
              <div class="tw-text-gray-700 tw-flex tw-items-center tw-text-sm tw-leading-none">
                <mail-icon class="tw-h-3.5 tw-w-3.5" />
                <a :href="`mailto:${contact.email}`" class="tw-ml-1.5 tw-text-gray-700 hover:tw-text-gray-500">{{ contact.email }}</a>
              </div>
              <div class="tw-text-gray-700 tw-flex tw-items-center tw-text-sm tw-leading-none tw-ml-3">
                <phone-icon class="tw-h-3.5 tw-w-3.5" />
                <base-phone-number-field class="tw-ml-1.5" :value="contact.phone" />
              </div>
            </div>
          </li>
          <li v-else>
            <div class="tw-text-primary tw-font-normal">Predictile Support</div>
            <div class="tw-flex tw-items-center tw-mt-1">
              <div class="tw-text-gray-700 tw-flex tw-items-center tw-text-sm tw-leading-none">
                <mail-icon class="tw-h-3.5 tw-w-3.5" />
                <a href="mailto:support@predictile.com" class="tw-ml-1.5 tw-text-gray-700 hover:tw-text-gray-500">support@predictile.com</a>
              </div>
            </div>
          </li>
        </ul>
      </base-card>
    </base-content>
  </div>
</template>

<script>
import { MailIcon, PhoneIcon } from "@/assets/svgs";
import { mapGetters } from "vuex";

export default {
  name: "BusinessSupport",
  components: {
    MailIcon,
    PhoneIcon,
  },
  props: {
    businessId: String,
  },
  data() {
    return {
      isLoading: true,
      supportContacts: [],
      business: {},
    };
  },
  computed: {
    ...mapGetters("role", ["roles", "isLocationFiltered"]),
    contact() {
      if (this.supportContacts.length > 0) {
        let ops = this.supportContacts.find((o) => o.contactType === "operations");
        if (ops != null) return ops;
        else return this.supportContacts[0];
      } else return { contactType: "No contacts setup for " + this.business.name, email: "", phone: "" };
    },
  },
  created() {
    this.getSupportContacts();
    this.getBusiness();
  },
  methods: {
    async getSupportContacts() {
      try {
        this.isLoading = true;
        const response = await this.$axios.get(`/businesses/${this.businessId}/contacts`);
        this.supportContacts = response.data;
      } finally {
        this.isLoading = false;
      }
    },
    async getBusiness() {
      try {
        this.isLoading = true;
        const response = await this.$axios.get(`/businesses/${this.businessId}`);
        this.business = response.data;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
<style scoped>
/* for mobile screens */
@media screen and (min-width: 768px) {
  .dummy-tw-margin {
    margin-left: -55px;
    margin-right: -55px;
    margin-top: -51px;
  }
}
</style>
